import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Lock, FileText, Database } from 'lucide-react';
import { Button, Section } from './Shared';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 px-5 overflow-hidden" data-id="element-133">
      {/* Background effects */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-brand-anthracite via-brand-dark to-brand-dark -z-10" data-id="element-134" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-brand-gold/5 blur-[120px] rounded-full -z-10" data-id="element-135" />

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-137">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-brand-red/30 bg-brand-red/10 text-brand-red text-xs font-bold tracking-widest uppercase mb-6" data-id="element-138">
            <Lock className="w-3 h-3" data-id="element-139" />
            <span data-id="element-140">Acceso Clasificado</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-141">
            LA BIBLIOTECA DOCUMENTAL <br className="hidden md:block" data-id="element-142" />
            <span className="text-brand-gold" data-id="element-143">MÁS IMPACTANTE</span> SOBRE LOS
            MISTERIOS QUE LA HISTORIA OFICIAL NUNCA TERMINÓ DE EXPLICAR
          </h1>

          <p className="text-base md:text-xl text-brand-muted max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-144">
            Accedé a una colección digital premium con 6 volúmenes centrales y 3
            bonos sobre OVNIs, UAP, archivos desclasificados, civilizaciones
            perdidas y grandes enigmas históricos.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative w-full max-w-4xl mx-auto mb-12" data-id="element-145">
          <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-transparent to-transparent z-10 h-full" data-id="element-146" />
          <img src="https://cdn.magicpatterns.com/uploads/g9b2hwXCqjNA6SvEzeo6ts/ChatGPT_Image_26_jun_2026,_18_39_00.png" alt="Colección Nos Mienten" className="w-full h-auto object-cover rounded-lg shadow-2xl relative z-0" data-id="element-147" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="w-full max-w-md mx-auto" data-id="element-148">
          <ul className="text-left space-y-3 mb-8 bg-brand-card/50 p-6 rounded-xl border border-brand-anthracite" data-id="element-149">
            {['6 volúmenes principales', '3 bonos incluidos', 'Acceso inmediato', 'Formato digital PDF', 'Lectura desde celular, tablet o PC'].map((bullet, idx) => <li key={idx} className="flex items-center gap-3 text-sm md:text-base text-brand-offWhite" data-id="element-150">
                <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-151" />
                <span data-id="element-152">{bullet}</span>
              </li>)}
          </ul>

          <Button fullWidth onClick={scrollToPricing} className="text-lg py-5" data-id="element-153">
            QUIERO ACCEDER AHORA
          </Button>
          <p className="text-xs text-brand-muted mt-4 text-center" data-id="element-154">
            Acceso inmediato • Formato digital • Bonos incluidos
          </p>
        </motion.div>
      </div>
    </section>;
}
export function Tension() {
  return <Section darker data-id="element-155">
      <div className="text-center max-w-3xl mx-auto" data-id="element-156">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-6" data-id="element-157">
          Nos dieron versiones incompletas. <br className="hidden md:block" data-id="element-158" />
          <span className="text-brand-red" data-id="element-159">Y con eso les alcanzó.</span>
        </h2>
        <div className="space-y-4 text-brand-muted text-base md:text-lg leading-relaxed" data-id="element-160">
          <p data-id="element-161">
            Durante décadas nos acostumbramos a consumir fragmentos: casos
            ridiculizados, documentos ocultos bajo sellos de confidencialidad,
            testigos ignorados y versiones oficiales que siempre resultaban más
            pequeñas que la evidencia disponible.
          </p>
          <p className="text-white font-medium mt-6 text-lg md:text-xl border-l-2 border-brand-gold pl-4 text-left" data-id="element-162">
            NOS MIENTEN nació para organizar ese caos. Para transformar la
            información dispersa en una biblioteca documental, estructurada y de
            nivel premium.
          </p>
        </div>
      </div>
    </Section>;
}
export function WhatThisIs() {
  return <Section data-id="element-163">
      <div className="max-w-2xl mx-auto text-center" data-id="element-164">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-6" data-id="element-165">
          Esto no es un ebook suelto. <br data-id="element-166" />
          <span className="text-brand-gold" data-id="element-167">
            Es una colección documental premium.
          </span>
        </h2>
        <p className="text-brand-muted mb-8 text-base md:text-lg" data-id="element-168">
          Diseñada específicamente para quienes buscan más que contenido
          disperso en internet. Es un archivo digital construido con rigor,
          pensado para ofrecer una experiencia de lectura inmersiva.
        </p>
        <div className="grid grid-cols-2 gap-4 max-w-md mx-auto" data-id="element-169">
          {[{
          icon: Database,
          text: 'Estructura'
        }, {
          icon: FileText,
          text: 'Contexto'
        }, {
          icon: Lock,
          text: 'Investigación'
        }, {
          icon: CheckCircle2,
          text: 'Diseño editorial'
        }].map((item, idx) => <div key={idx} className="flex items-center gap-2 text-sm text-brand-offWhite bg-brand-dark p-3 rounded-lg border border-brand-card" data-id="element-170">
              <item.icon className="w-4 h-4 text-brand-gold" data-id="element-171" />
              <span data-id="element-172">{item.text}</span>
            </div>)}
        </div>
      </div>
    </Section>;
}
export function MainCollection() {
  return <Section darker className="text-center" data-id="element-173">
      <h2 className="text-xs font-bold tracking-widest text-brand-gold uppercase mb-3" data-id="element-174">
        El núcleo del archivo
      </h2>
      <h3 className="text-2xl md:text-4xl font-bold text-white mb-8" data-id="element-175">
        Lo que recibís al entrar al archivo
      </h3>

      <div className="bg-brand-anthracite border border-brand-card rounded-2xl p-6 md:p-10 max-w-4xl mx-auto text-left relative overflow-hidden" data-id="element-176">
        <div className="absolute top-0 right-0 w-64 h-64 bg-brand-gold/5 blur-3xl rounded-full" data-id="element-177" />

        <div className="flex flex-col md:flex-row gap-8 items-center relative z-10" data-id="element-178">
          <div className="w-full md:w-1/3" data-id="element-179">
            <img src="https://cdn.magicpatterns.com/uploads/g9b2hwXCqjNA6SvEzeo6ts/ChatGPT_Image_26_jun_2026,_18_39_00.png" alt="Nos Mienten Cover" className="w-full h-auto rounded shadow-xl object-cover object-left h-[300px]" data-id="element-180" />
          </div>
          <div className="w-full md:w-2/3" data-id="element-181">
            <h4 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-182">
              NOS MIENTEN: El Archivo de los No Contactados
            </h4>
            <p className="text-brand-gold text-sm font-medium mb-4" data-id="element-183">
              LA OBRA CENTRAL DE LA COLECCIÓN
            </p>
            <p className="text-brand-muted text-base leading-relaxed" data-id="element-184">
              Un sistema documental premium dividido en 6 volúmenes para
              recorrer el fenómeno OVNI/UAP desde sus primeros registros hasta
              las revelaciones más recientes. Diseñado para leerse como una
              serie documental, conectando los puntos que la historia oficial
              dejó sueltos.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}